export { SlideshowComponent } from './slideshow'
